export { SlideshowComponent } from './slideshow'
